// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandedBox_root__E_uQ1"};